import {makeAutoObservable} from "mobx"

export interface Notice {message: string, fixPath?: string }

class NoticeController {
    constructor() {
        makeAutoObservable(this)
    }

    private _success: string[] = []

    get success(): string[] {
        return this._success
    }

    set success(value: string[]) {
        this._success = value
    }

    private _errors: Notice[] = []

    get errors(): Notice[] {
        return this._errors
    }

    deleteErrorByIndex(index: number) {
        this._errors.splice(index, 1)
    }

    set errors(value: Notice[]) {
        this._errors = value
    }

    clear() {
        this._errors = []
        this._success = []
    }

    clearSuccess() {
        this._success = []
    }
}

export const noticeController = new NoticeController()